import router from './router'
import PaymentMessages from './localization'

export default {
  router,
  localization: PaymentMessages,
}
